import { render, staticRenderFns } from "./detail_pickup.vue?vue&type=template&id=ce32b0ca&scoped=true&"
import script from "./detail_pickup.vue?vue&type=script&lang=js&"
export * from "./detail_pickup.vue?vue&type=script&lang=js&"
import style0 from "./detail_pickup.vue?vue&type=style&index=0&id=ce32b0ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce32b0ca",
  null
  
)

export default component.exports